import LoginPromptPopup from '@src/components/LoginPromptPopup';
import React from 'react';

type Props = {
  isVisible: boolean;
  popupRef: React.RefObject<HTMLDivElement>;
  className?: string;
  onClose?: () => void;
};

export default function FavoriteLoginPopup(props: Props) {
  return (
    <LoginPromptPopup
      {...props}
      message='いいねするには、ログインしてください。'
    />
  );
}
